//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: 'BankManage',
};
